import {BASE_ADMIN_PATH, getBaseRequestConfig, LOCAL_BASE_PATH} from './baseRequestConfig';
import httpRequest from './httpRequest';

export function getHomePageConfig(ignore, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/home`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function putHomePageConfig(ignore, body, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${BASE_ADMIN_PATH}/home`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: body,
  });

  return httpRequest(requestConfig);
}

export function getHomePage() {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/home`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}
